import client from '@/api/client';
import { gql } from '@apollo/client';
import imagesFragments from '@/gql-fragments/images';
import listFragments from '@/gql-fragments/student-lists';
import teacherFragments from '@/gql-fragments/teacher';
import userFragments from '@/gql-fragments/user';

const addStudentByInvite = (data: {
  teacherId: number;
  studentId: number;
  courseId: number;
  force: number;
}) => client
  .mutate({
    mutation: gql`
      mutation(
        $teacherId: Int,
        $studentId: Int,
        $courseId: Int
        $force: Int,
      ) {
        addStudentByInvite(
          teacherId: $teacherId,
          studentId: $studentId,
          courseId: $courseId
          force: $force,
        ) {
          status
        }
      }
    `,
    variables: {
      ...data,
    },
  });

const getTeacherInfo = () => client
  .query({
    query: gql`
      query {
        getTeacherInfo {
          ...Teacher
          user {
            ...User
            avatar {
              ...Avatar
            }
          }
        }
      }
      ${imagesFragments.Avatar}
      ${teacherFragments.Teacher}
      ${userFragments.User}
    `,
  });

const getTeacherInfoForTeacher = () => client
  .query({
    query: gql`
      query {
        getTeacherInfo {
          ...Teacher
          user {
            ...User
            avatar {
              ...Avatar
            }
          }
        }
      }
      ${imagesFragments.Avatar}
      ${teacherFragments.Teacher}
      ${userFragments.User}
    `,
  });

const getTeacherStudentsList = (uid: number) => client
  .query({
    query: gql`
      query(
        $uid: Int,
      ) {
        getTeacherStudentsList(
          uid: $uid,
        ) {
          ...List
          session {
            id
            progress
            status
            lessonsFinishedCount
            lastLessonDate
            student {
              id
              name
              country
              city
              skype
              phone
              balance
              englishLevel
              user {
                ...User
                avatar {
                  ...Avatar
                }
              }
            }
            course {
              ...Course
            }
            nextLesson {
              id
            }
          }
        }
        getClientState(
          state: "studentCard.testStudent.courseId"
        ) {
          id
          state
          value
        }
      }
      ${listFragments.Course}
      ${listFragments.List}
      ${userFragments.User}
      ${imagesFragments.Avatar}
    `,
    variables: {
      uid,
    },
  });

export default {
  addStudentByInvite,
  getTeacherInfo,
  getTeacherStudentsList,
  getTeacherInfoForTeacher,
};
